var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 95,
    viewBox: "0 0 76 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 76,
    height: 11,
    rx: 2,
    fill: "#F57024"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 32,
    height: 12,
    rx: 2,
    fill: "#F57024"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 9,
    width: 16,
    height: 2,
    rx: 1,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C0.895431 4 0 4.89543 0 6V7C0 5.89543 0.895431 5 2 5H74C75.1046 5 76 5.89543 76 7V6C76 4.89543 75.1046 4 74 4H2Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 78C5 76.3431 6.34315 75 8 75C9.65685 75 11 76.3431 11 78V93C11 94.1046 10.1046 95 9 95H7C5.89543 95 5 94.1046 5 93V78Z",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 6,
    height: 10,
    rx: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 78C65 76.3431 66.3431 75 68 75C69.6569 75 71 76.3431 71 78V93C71 94.1046 70.1046 95 69 95H67C65.8954 95 65 94.1046 65 93V78Z",
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 77,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 80,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 83,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 86,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 89,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 92,
    width: 2,
    height: 1,
    rx: 0.5,
    fill: "#DDDDDD",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15Z",
    fill: "#F57024"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3955 94H60.3906C64.6517 94 68.1649 90.6601 68.3804 86.4046L71.9958 15H69.0007L65.3853 86.4046C65.1698 90.6601 61.6565 94 57.3955 94Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15H4L7.61542 86.4045C7.83089 90.6601 11.3441 94 15.6052 94H18.6052C14.3441 94 10.8309 90.6601 10.6154 86.4045L7 15Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 15H4L4.35443 22H71.6456L72 15Z",
    fill: "url(#paint0_linear_176_729)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3569 87.2155C22.7308 85.3458 24.3725 84 26.2792 84H49.7208C51.6275 84 53.2692 85.3458 53.6431 87.2155L55 94H21L22.3569 87.2155Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.478 87.3492C23.783 85.9766 25.0004 85 26.4065 85H49.5935C50.9996 85 52.217 85.9766 52.522 87.3492L54 94H22L23.478 87.3492Z",
    fill: "#F57024"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C22 0.895432 22.8954 0 24 0H52C53.1046 0 54 0.895432 54 2V4H74C75.1046 4 76 4.89543 76 6V13C76 14.1046 75.1046 15 74 15H72L68.3846 86.4046C68.1691 90.6601 64.6559 94 60.3948 94H15.6052C11.3441 94 7.83089 90.6601 7.61542 86.4045L4 15H2C0.895432 15 0 14.1046 0 13V6C0 4.89543 0.895432 4 2 4H22V2Z",
    fill: "url(#paint1_linear_176_729)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_729)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 40,
    width: 50,
    height: 18,
    rx: 4,
    fill: "black",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.588 48.848C23.588 49.496 23.528 50.088 23.408 50.624C23.296 51.152 23.116 51.608 22.868 51.992C22.628 52.368 22.32 52.66 21.944 52.868C21.576 53.076 21.14 53.18 20.636 53.18C20.132 53.18 19.692 53.076 19.316 52.868C18.948 52.66 18.64 52.368 18.392 51.992C18.152 51.608 17.972 51.152 17.852 50.624C17.732 50.088 17.672 49.496 17.672 48.848C17.672 48.2 17.732 47.608 17.852 47.072C17.972 46.536 18.152 46.08 18.392 45.704C18.64 45.32 18.948 45.024 19.316 44.816C19.692 44.6 20.132 44.492 20.636 44.492C21.14 44.492 21.576 44.6 21.944 44.816C22.32 45.024 22.628 45.32 22.868 45.704C23.116 46.08 23.296 46.536 23.408 47.072C23.528 47.608 23.588 48.2 23.588 48.848ZM22.436 48.848C22.436 48.344 22.404 47.884 22.34 47.468C22.276 47.052 22.172 46.696 22.028 46.4C21.884 46.096 21.696 45.86 21.464 45.692C21.24 45.524 20.964 45.44 20.636 45.44C20.308 45.44 20.028 45.524 19.796 45.692C19.572 45.86 19.388 46.096 19.244 46.4C19.1 46.696 18.992 47.052 18.92 47.468C18.856 47.884 18.824 48.344 18.824 48.848C18.824 49.352 18.856 49.812 18.92 50.228C18.992 50.644 19.1 51 19.244 51.296C19.388 51.592 19.572 51.824 19.796 51.992C20.028 52.152 20.308 52.232 20.636 52.232C20.964 52.232 21.24 52.152 21.464 51.992C21.696 51.824 21.884 51.592 22.028 51.296C22.172 51 22.276 50.644 22.34 50.228C22.404 49.812 22.436 49.352 22.436 48.848ZM25.2736 44.804C25.8336 44.668 26.3736 44.6 26.8936 44.6C27.3096 44.6 27.6856 44.648 28.0216 44.744C28.3576 44.84 28.6456 44.992 28.8856 45.2C29.1256 45.408 29.3096 45.676 29.4376 46.004C29.5736 46.332 29.6416 46.728 29.6416 47.192C29.6416 47.768 29.5296 48.236 29.3056 48.596C29.0896 48.948 28.7936 49.216 28.4176 49.4C28.5136 49.56 28.6336 49.78 28.7776 50.06C28.9296 50.332 29.0816 50.636 29.2336 50.972C29.3936 51.3 29.5456 51.64 29.6896 51.992C29.8416 52.344 29.9696 52.68 30.0736 53H28.9936C28.9056 52.76 28.7936 52.488 28.6576 52.184C28.5296 51.88 28.3936 51.58 28.2496 51.284C28.1056 50.98 27.9616 50.692 27.8176 50.42C27.6736 50.14 27.5456 49.904 27.4336 49.712C27.3056 49.728 27.1736 49.74 27.0376 49.748C26.9016 49.756 26.7656 49.76 26.6296 49.76H26.3296V53H25.2736V44.804ZM26.3296 48.872H26.7856C27.3376 48.872 27.7616 48.748 28.0576 48.5C28.3536 48.244 28.5016 47.808 28.5016 47.192C28.5016 46.88 28.4616 46.62 28.3816 46.412C28.3096 46.196 28.2016 46.028 28.0576 45.908C27.9216 45.78 27.7536 45.688 27.5536 45.632C27.3616 45.576 27.1456 45.548 26.9056 45.548C26.6976 45.548 26.5056 45.56 26.3296 45.584V48.872ZM30.9725 48.836C30.9725 48.052 31.0445 47.384 31.1885 46.832C31.3325 46.28 31.5365 45.832 31.8005 45.488C32.0725 45.136 32.3965 44.884 32.7725 44.732C33.1565 44.572 33.5845 44.492 34.0565 44.492C34.4165 44.492 34.7445 44.544 35.0405 44.648C35.3365 44.744 35.5765 44.856 35.7605 44.984L35.4245 45.884C35.2405 45.756 35.0405 45.652 34.8245 45.572C34.6085 45.484 34.3605 45.44 34.0805 45.44C33.3845 45.44 32.8845 45.724 32.5805 46.292C32.2765 46.852 32.1245 47.7 32.1245 48.836C32.1245 49.444 32.1685 49.964 32.2565 50.396C32.3525 50.828 32.4845 51.18 32.6525 51.452C32.8205 51.724 33.0245 51.924 33.2645 52.052C33.5045 52.18 33.7725 52.244 34.0685 52.244C34.3165 52.244 34.5285 52.216 34.7045 52.16V48.908H35.7845V52.82C35.5685 52.924 35.3005 53.012 34.9805 53.084C34.6605 53.156 34.3245 53.192 33.9725 53.192C33.5405 53.192 33.1405 53.108 32.7725 52.94C32.4045 52.764 32.0845 52.5 31.8125 52.148C31.5485 51.788 31.3405 51.336 31.1885 50.792C31.0445 50.24 30.9725 49.588 30.9725 48.836ZM40.2052 44.684C40.3972 45.284 40.5852 45.892 40.7692 46.508C40.9612 47.116 41.1452 47.756 41.3212 48.428C41.5052 49.1 41.6852 49.812 41.8612 50.564C42.0452 51.316 42.2292 52.128 42.4132 53H41.3332C41.2692 52.64 41.2012 52.284 41.1292 51.932C41.0652 51.58 40.9972 51.228 40.9252 50.876H38.3092C38.2292 51.228 38.1572 51.58 38.0932 51.932C38.0292 52.284 37.9652 52.64 37.9012 53H36.8572C37.0332 52.128 37.2132 51.316 37.3972 50.564C37.5812 49.812 37.7612 49.1 37.9372 48.428C38.1212 47.756 38.3052 47.116 38.4892 46.508C38.6812 45.892 38.8732 45.284 39.0652 44.684H40.2052ZM39.6172 45.908C39.4172 46.572 39.2252 47.24 39.0412 47.912C38.8572 48.584 38.6812 49.272 38.5132 49.976H40.7092C40.5492 49.272 40.3772 48.584 40.1932 47.912C40.0092 47.24 39.8172 46.572 39.6172 45.908ZM47.7403 53C47.5483 52.528 47.3283 52.02 47.0803 51.476C46.8403 50.924 46.5843 50.372 46.3123 49.82C46.0483 49.26 45.7763 48.708 45.4963 48.164C45.2163 47.612 44.9403 47.1 44.6683 46.628V53H43.6603V44.684H44.5603C44.8643 45.18 45.1563 45.688 45.4363 46.208C45.7243 46.728 45.9963 47.244 46.2523 47.756C46.5083 48.26 46.7483 48.76 46.9723 49.256C47.2043 49.744 47.4163 50.208 47.6083 50.648V44.684H48.6163V53H47.7403ZM50.633 44.684H51.713V53H50.633V44.684ZM56.4028 53.18C55.4268 53.18 54.6788 52.816 54.1588 52.088C53.6388 51.36 53.3788 50.236 53.3788 48.716C53.3788 47.94 53.4508 47.284 53.5948 46.748C53.7468 46.212 53.9548 45.776 54.2188 45.44C54.4828 45.104 54.7948 44.864 55.1548 44.72C55.5148 44.568 55.9068 44.492 56.3308 44.492C56.6828 44.492 57.0108 44.54 57.3148 44.636C57.6188 44.724 57.8668 44.836 58.0588 44.972L57.7348 45.872C57.5428 45.744 57.3348 45.64 57.1108 45.56C56.8948 45.48 56.6428 45.44 56.3548 45.44C55.7148 45.44 55.2508 45.708 54.9628 46.244C54.6748 46.772 54.5308 47.596 54.5308 48.716C54.5308 49.844 54.6828 50.712 54.9868 51.32C55.2908 51.928 55.7868 52.232 56.4748 52.232C56.8028 52.232 57.0668 52.192 57.2668 52.112C57.4748 52.032 57.6748 51.928 57.8668 51.8L58.1668 52.652C57.9828 52.796 57.7388 52.92 57.4348 53.024C57.1388 53.128 56.7948 53.18 56.4028 53.18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_729",
    x: 12,
    y: 40,
    width: 52,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_729"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_729",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_729",
    x1: 38,
    y1: 15,
    x2: 38,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_729",
    x1: 0,
    y1: 0,
    x2: 76,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganic);
export default __webpack_public_path__ + "static/media/organic.cbb9f19d8a4dc4c89eb578f1d21b4c11.svg";
export { ForwardRef as ReactComponent };